import script from "./TechnologyAssetsAddNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechnologyAssetsAddNew.vue?vue&type=script&setup=true&lang=ts"

import "./TechnologyAssetsAddNew.vue?vue&type=style&index=0&id=08cfc00d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08cfc00d"]])

export default __exports__